import axios from 'axios';

const nominatimOpenStreetMapApiUrl = 'https://nominatim.openstreetmap.org/';
const searchQueryEndpoint = 'search?q=';
const searchEndpointJsonParam = '&format=json';
const withAddressDetails = '&addressdetails=1';

interface NominatimAddress {
  village?: string;
  town?: string;
  city?: string;
  municipality?: string;
  postcode: string;
}

interface NominatimSearchResult {
  lat: string;
  lon: string;
  address: NominatimAddress;
}

export const getCoordinatesFromAddress = async (address: string) => {
  const formattedAddress = address.trim().replace(new RegExp('\\s+'), '+');
  const completeUrl =
    nominatimOpenStreetMapApiUrl +
    searchQueryEndpoint +
    formattedAddress +
    searchEndpointJsonParam +
    withAddressDetails;

  const promise = axios.get<NominatimSearchResult[]>(completeUrl, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Referer: 'https://www.pharmagarde.be/',
    },
  });

  const data = await promise.then((res) => (res.status === 200 ? res.data : undefined));

  return data;
};
